import React from 'react';
import ReactDOM from 'react-dom/client';
/* Load order is the cascade order. Bootstrap first (it is the base layer that
   everything else overrides), then our responsive foundation, then the global
   resets. It used to be pulled from a CDN in index.html *and* imported by seven
   different components — one render-blocking third-party request for a package
   that was already in the bundle. */
import 'bootstrap/dist/css/bootstrap.min.css';
import './responsive.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);

// Pass a function to start measuring performance, e.g. reportWebVitals(console.log)
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
